var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 181.97,
    y: 190.111,
    style: {
      fill: "#FEC93E"
    },
    width: 40.24,
    height: 255.88
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A738"
    },
    d: "M229.106,231.899h-54.034c-3.983,0-7.212-3.229-7.212-7.212v-24.493h68.458v24.493 C236.318,228.671,233.089,231.899,229.106,231.899z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A738"
    },
    d: "M236.318,436.498H167.86v-24.493c0-3.983,3.229-7.212,7.212-7.212h54.034 c3.983,0,7.212,3.229,7.212,7.212L236.318,436.498L236.318,436.498z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 289.79,
    y: 190.111,
    style: {
      fill: "#FEC93E"
    },
    width: 40.24,
    height: 255.88
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A738"
    },
    d: "M336.928,231.899h-54.034c-3.983,0-7.212-3.229-7.212-7.212v-24.493h68.458v24.493 C344.14,228.671,340.911,231.899,336.928,231.899z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A738"
    },
    d: "M344.14,436.498h-68.458v-24.493c0-3.983,3.229-7.212,7.212-7.212h54.034 c3.983,0,7.212,3.229,7.212,7.212V436.498z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 397.61,
    y: 190.111,
    style: {
      fill: "#FEC93E"
    },
    width: 40.24,
    height: 255.88
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A738"
    },
    d: "M444.75,231.899h-54.034c-3.983,0-7.212-3.229-7.212-7.212v-24.493h68.458v24.493 C451.962,228.671,448.733,231.899,444.75,231.899z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A738"
    },
    d: "M451.962,436.498h-68.458v-24.493c0-3.983,3.229-7.212,7.212-7.212h54.034 c3.983,0,7.212,3.229,7.212,7.212V436.498z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 74.15,
    y: 190.111,
    style: {
      fill: "#FEC93E"
    },
    width: 40.24,
    height: 255.88
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A738"
    },
    d: "M121.285,231.899H67.25c-3.983,0-7.212-3.229-7.212-7.212v-24.493h68.458v24.493 C128.496,228.671,125.268,231.899,121.285,231.899z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A738"
    },
    d: "M128.496,436.498H60.038v-24.493c0-3.983,3.229-7.212,7.212-7.212h54.034 c3.983,0,7.212,3.229,7.212,7.212V436.498z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC93E"
    },
    d: "M481.102,200.195H30.898c-3.894,0-7.05-3.157-7.05-7.05v-30.117c0-3.894,3.157-7.05,7.05-7.05 h450.203c3.894,0,7.05,3.157,7.05,7.05v30.117C488.152,197.038,484.996,200.195,481.102,200.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFB635"
    },
    d: "M481.102,155.977h-48.666v44.218h48.666c3.894,0,7.05-3.157,7.05-7.05v-30.117 C488.152,159.134,484.996,155.977,481.102,155.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC93E"
    },
    d: "M492.541,467.17H19.459v-19.89c0-5.955,4.827-10.782,10.782-10.782H481.76 c5.955,0,10.782,4.827,10.782,10.782v19.89H492.541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFB635"
    },
    d: "M481.759,436.498h-44.935v30.672h55.716v-19.89C492.541,441.325,487.714,436.498,481.759,436.498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A738"
    },
    d: "M508.296,497.842H3.704c-2.046,0-3.704-1.659-3.704-3.704v-16.186 c0-5.955,4.827-10.782,10.782-10.782h490.437c5.955,0,10.782,4.827,10.782,10.782v16.186 C512,496.184,510.341,497.842,508.296,497.842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8932E"
    },
    d: "M501.218,467.17h-44.677v30.672h51.754c2.046,0,3.704-1.659,3.704-3.705v-16.186 C512,471.997,507.173,467.17,501.218,467.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A738"
    },
    d: "M256.27,15.038L2.879,147.958c-1.405,0.737-2.285,2.192-2.285,3.778v13.611 c0,2.356,1.91,4.266,4.266,4.266h502.28c2.356,0,4.266-1.91,4.266-4.266v-13.648c0-1.567-0.859-3.008-2.237-3.753L263.485,15.083 C261.238,13.868,258.533,13.851,256.27,15.038z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8932E"
    },
    d: "M509.169,147.946L263.485,15.083c-2.247-1.215-4.952-1.233-7.215-0.046l-43.934,23.046 l243.219,131.53h51.585c2.356,0,4.266-1.91,4.266-4.267v-13.648C511.406,150.132,510.547,148.691,509.169,147.946z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.41ffddb0b9c8ac5df0e0ad7e1eaa153a.svg";
export { ForwardRef as ReactComponent };